import React, { useEffect, useRef } from "react";
import gsap from "gsap";

export default function PreLoader({ onDone }) {
  const root = useRef(null);

  useEffect(() => {
    const el = root.current;
    if (!el) return;

    const tl = gsap.timeline({
      onComplete: () => {
        if (typeof onDone === "function") onDone();
      },
    });

    tl.set(el, { clipPath: "inset(0 0 0 0)" })
      .to({}, { duration: 1.5 })
      .to(el, {
        clipPath: "inset(0 0 100% 0)",
        duration: 0.9,
        ease: "power3.inOut",
      });

    return () => {
      tl.kill();
    };
  }, [onDone]);

  return (
    <div
      ref={root}
      aria-hidden="true"
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-[#0A0A0A]"
      style={{ clipPath: "inset(0 0 0 0)" }}
    >
      <div className="font-display uppercase tracking-[0.4em] text-white text-2xl md:text-3xl">
        RF KFZ
      </div>
    </div>
  );
}
